import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import App from './App_testAdk';
// import App from './App_testMls';

// import App from './App_TestStarknetJs';
// import App from './App_testAuthToDapp';
// import App from './App_testBindDid';
// import App from './App_testFollowUser';
// import App from './App_testFollowUserSDK';
// import App from './App_testPoweredByBtn';

import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
